import { createSelector } from "@reduxjs/toolkit";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraft";
import { getModErrors } from "@src/store/slices/experienceBuilder/common/utils/getModErrors";

export const getVariationDraftErrors = createSelector(
  getVariationDraft,
  (mod) => {
    if (!mod) return undefined;

    const errors = getModErrors(mod);
    if (Object.keys(errors).length === 0) return undefined;

    return errors;
  }
);
